module.exports = __webpack_public_path__ + "static/full04-55671155724a0d7e4bbc02fe04010d6e.png";